import { render } from "./menu.vue?vue&type=template&id=b3575a0e&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=b3575a0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3575a0e"

export default script